export default __webpack_public_path__ + "static/media/330_dummy2016-sprachunterricht01-mobile-de.c134759d.png";